module.exports = __webpack_public_path__ + "static/img/data_chengse.5372ffb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/data_chengse.png
// module id = YMIk
// module chunks = 2